const BASE_URL = process.env.PURCHASE_API_URL;

export const SLATE_PURCHASE_STATUS_ENDPOINTS = {
  STATUS: `${BASE_URL}/api/v1/dealer/status`
};
